<div class="divParent">
  <h2 class="title">Descripción Caso {{ title }}</h2>
  <div class="divider"></div>
  <div class="description">
    <p>
      {{ description }}
    </p>
  </div>
  <div class="buttons">
    <button mat-stroked-button mat-dialog-close>Cerrar</button>
  </div>
</div>
